import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ServiceHero } from '../components/services/ServiceHero';
import { ServiceProcess } from '../components/services/ServiceProcess';
import { ServiceIncluded } from '../components/services/ServiceIncluded';
import { ServiceOutcomes } from '../components/services/ServiceOutcomes';
import { ServiceWhySixWeeks } from '../components/services/ServiceWhySixWeeks';
import { ServiceEntryPoint } from '../components/services/ServiceEntryPoint';
import { ServiceWorkshops } from '../components/services/ServiceWorkshops';
import { ServiceClosingCta } from '../components/services/ServiceClosingCta';
export function ServicesPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-518" data-mp="2pyzl9aqi6p47">
      <Navigation data-id="element-519" data-mp="2uzn95njfqpu7" />
      <main className="flex-grow" data-id="element-520" data-mp="2v05d76cca8co">
        <ServiceHero data-id="element-521" data-mp="2uwrd64r5eb8e" />
        <ServiceProcess data-id="element-522" data-mp="2zx5j9h96vb3s" />
        <ServiceIncluded data-id="element-523" data-mp="2zygntjagkmvy" />
        <ServiceOutcomes data-id="element-524" data-mp="2zxx7u84dc8kk" />
        <ServiceWhySixWeeks data-id="element-525" data-mp="2xk189whoqrbb" />
        <ServiceEntryPoint data-id="element-526" data-mp="2xkax3gqzusff" />
        <ServiceWorkshops data-id="element-527" data-mp="2xlm19hocq272" />
        <ServiceClosingCta data-id="element-528" data-mp="2xhoi4w1rxan6" />
      </main>
      <Footer data-id="element-529" data-mp="2skoip3zfj651" />
    </div>;
}